import CustomerSidebar from "./CustomerSidebar";
import { useState } from "react";
import CardItemsComponent from "context/CardItemsProvider";
import WithAuthentication from "Authentication/AuthenticationContext.ts";
import { useContext } from "react";

export default function CustomerLayout({ children }) {
  const auth = useContext(WithAuthentication);
  console.log("***", auth);
  return (
    <div dir="rtl" className="d-flex " style={{ height: "auto" }}>
      {/* <CustomerSidebar
        fullName={auth.userInfo.fullName}
        img={null}
      ></CustomerSidebar> */}
      <div className="pt-1 pb-4" style={{ width: "100%" }}>
        {children}
      </div>
    </div>
  );
}
